export default "__VITE_ASSET__VW2DoJOK__ 640w, __VITE_ASSET__Begnqwka__ 1024w, __VITE_ASSET__SpgzhCkh__ 1280w";